export default {
  addressLabel: "地址",
  tagAlt: "标签",
  chainAlt: "链路",
  debugWidth: "我是宽度",
};
